import React from 'react'
import { useCallback } from 'sb-hooks'
import { links, snowplow, constants } from 'common/helpers'
import type { Events } from 'common/helpers/analytics/snowplow/config'

import { openResubscribeConfirmationModal } from 'compositions/modals/ResubscribeConfirmationModal/ResubscribeConfirmationModal'

import { Button } from 'components/_new/controls'
import type { ButtonProps, AddToQueueMetadata, AddToProduct } from 'components/_new/controls'

import messages from './messages'


export type ResubscribeButtonProps = Partial<Pick<ButtonProps, 'className' | 'title' | 'fullWidth' | 'fullWidthOnMobile' | 'dataTestId' | 'to' | 'onClick'>> & {
  placement: Events['Resubscribe click']['placement']
  color?: ButtonProps['color']
  size?: ButtonProps['size']
  isFirstTimeResubscribeFlow?: boolean
} & AllOrNothing<{
  productToAdd?: AddToProduct
  metadata?: AddToQueueMetadata
}>

const ResubscribeButton: React.FunctionComponent<ResubscribeButtonProps> = (props) => {
  const {
    className, fullWidth, fullWidthOnMobile, placement, onClick,
    size = 'md',
    color = 'brand',
    title = messages.title,
    to = links.resubscribe,
    dataTestId = 'resubscribeButton',

    // ab-test flow
    isFirstTimeResubscribeFlow,
    productToAdd,
    metadata,
  } = props


  const handleClick = useCallback((event) => {
    snowplow.track(constants.snowplowEvents.resubscribeClick, {
      placement,
    })

    if (isFirstTimeResubscribeFlow) {
      openResubscribeConfirmationModal({
        resubscribeCode: constants.resubscribeTypes.resubfreeproduct,
        placement,
        productToAdd,
        metadata,
      })
    }

    if (typeof onClick === 'function') {
      onClick(event)
    }
  }, [ isFirstTimeResubscribeFlow, placement, productToAdd, metadata, onClick ])

  return (
    <Button
      className={className}
      title={title}
      to={isFirstTimeResubscribeFlow ? null : to}
      size={size}
      color={color}
      fullWidth={fullWidth}
      fullWidthOnMobile={fullWidthOnMobile}
      dataTestId={dataTestId}
      onClick={handleClick}
    />
  )
}


export default ResubscribeButton
